export enum ContactType {
    Adviser = 'Adviser',
    Client = 'Client',
    Intermediary = 'Intermediary',
    Lead = 'Lead',
    Organisation = 'Organisation',
    Person = 'Person',
}
